import React from "react";
import { Container } from "../app.style";

const DatenschutzScreen = () => {
  return (
    <main>
      <section>
        <Container>
          <h1>Datenschutzbestimmungen für KATAPULT-App</h1>
          <h2>Haftungsausschluss für den Entwickler</h2>
          <p>
            Bitte beachten Sie, dass diese App von Andreas Bonke ("Entwickler")
            als Freelancer für KATAPULT entwickelt wurde. Der Entwickler hat die
            App entwickelt und stellt sie im Auftrag von KATAPULT zur Verfügung.
            Der Entwickler ist nicht für die Inhalte, Informationen oder
            Materialien verantwortlich, die über die App zur Verfügung gestellt
            werden und gibt keine Zusicherungen oder Gewährleistungen bezüglich
            der Genauigkeit, Zuverlässigkeit oder Vollständigkeit dieser
            Inhalte, Informationen oder Materialien ab. Jegliche Haftung in
            Bezug auf die Inhalte, Informationen oder Materialien, die über die
            App zur Verfügung gestellt werden, liegt allein bei KATAPULT.
          </p>
          <h2>Datenschutzbestimmungen</h2>
          <p>
            Andreas Bonke und KATAPULT ("wir”) respektieren die Privatsphäre
            unserer Nutzer:innen. Diese Datenschutzbestimmungen erklären, wie
            wir Informationen sammeln, verwenden, offenlegen, schützen und
            speichern, die Sie uns zur Verfügung stellen oder die wir von Ihnen
            sammeln, wenn Sie unsere App KATAPULT: dein mobiles Magazin ("App")
            verwenden. Indem Sie unsere App verwenden, stimmen Sie der
            Erfassung, Nutzung und Offenlegung Ihrer persönlichen Daten gemäß
            diesen Datenschutzbestimmungen zu. Wenn Sie mit diesen
            Datenschutzbestimmungen nicht einverstanden sind, verwenden Sie
            bitte unsere App nicht.
          </p>
          <ol>
            <li>
              <h3>Verantwortliche Stelle</h3>
              <p>
                Katapult-Magazin gGmbH <br /> Wilhelm-Holtz-Straße 9 <br />{" "}
                17489 Greifswald
              </p>
            </li>
            <li>
              <h3>Allgemeines zur Datenverarbeitung</h3>
              <p>
                Wir verarbeiten personenbezogene Daten unserer Nutzer:innen
                grundsätzlich nur, soweit dies zur Bereitstellung einer
                funktionsfähigen App, sowie zur Verbesserung, Analyse und
                Optimierung der App erforderlich ist. Die Verarbeitung erfolgt
                nur, wenn die Nutzer:innen in die Datenverarbeitung eingewilligt
                haben oder wenn die Verarbeitung durch gesetzliche Vorschriften
                gestattet ist.
              </p>
            </li>
            <li>
              <h3>Verarbeitung personenbezogener Daten</h3>
              <p>
                Wir verarbeiten personenbezogene Daten unserer
                Nutzer:innen:innen grundsätzlich nur, soweit dies zur
                Bereitstellung einer funktionsfähigen App, sowie zur
                Verbesserung, Analyse und Optimierung der App erforderlich ist.
                Die Verarbeitung erfolgt nur, wenn die Nutzer:innen:innen in die
                Datenverarbeitung eingewilligt haben oder wenn die Verarbeitung
                durch gesetzliche Vorschriften gestattet ist.
              </p>
              <ol type="a">
                <li>
                  <p>
                    Bei der Nutzung unserer App erheben wir folgende
                    personenbezogene Daten:
                  </p>
                  <ul>
                    <li>Nutzername (Optional bei Registrierung)</li>
                    <li>E-Mail-Adresse (bei Registrierung)</li>
                    <li>Passwort (bei Registrierung)</li>
                  </ul>
                </li>
                <li>
                  <p>Diese Daten werden zu folgenden Zwecken verarbeitet:</p>
                  <ul>
                    <li>Bereitstellung der App und ihrer Funktionen</li>
                    <li>Analyse und Optimierung der App</li>
                  </ul>
                </li>
                <li>
                  <p>
                    Rechtsgrundlage für die Verarbeitung personenbezogener Daten
                    ist Art. 6 Abs. 1 lit. a (Einwilligung) und/oder Art. 6 Abs.
                    1 lit. f (berechtigtes Interesse) DSGVO.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h3>Weitergabe von Daten an Dritte</h3>
              <p>
                Wir geben personenbezogene Daten an Dritte nur weiter, wenn dies
                im Rahmen der Vertragsabwicklung oder zur Durchführung
                vorvertraglicher Maßnahmen erforderlich ist oder wenn eine
                gesetzliche Verpflichtung besteht. Eine Übermittlung von
                personenbezogenen Daten an ein Drittland oder eine
                internationale Organisation findet nicht statt.
              </p>
            </li>
            <li>
              <h3>Nutzung von Firebase</h3>
              <p>
                Wir nutzen den Cloud-Service Firebase der Firma Google LLC, 1600
                Amphitheatre Parkway, Mountain View, CA 94043, USA, um
                Datenbank- und Authentifizierungsdienste bereitzustellen. Die
                Datenschutzerklärung von Google finden Sie unter:
                https://www.google.com/policies/privacy/.
              </p>
            </li>
            <li>
              <h3>Rechte der betroffenen Person</h3>
              <ol type="a">
                <li>
                  <p>
                    Nutzer:innen unserer App haben das Recht, Auskunft über die
                    von uns verarbeiteten personenbezogenen Daten zu verlangen.
                    Dies umfasst Informationen über den Verarbeitungszweck, die
                    Kategorien der verarbeiteten Daten, die Empfänger oder
                    Kategorien von Empfängern, die Dauer der Speicherung und die
                    Herkunft der Daten.
                  </p>
                </li>
                <li>
                  <p>
                    Nutzer:innen haben das Recht, die Berichtigung unrichtiger
                    oder unvollständiger personenbezogener Daten zu verlangen.
                  </p>
                </li>
                <li>
                  <p>
                    Nutzer:innen haben das Recht, die Löschung ihrer
                    personenbezogenen Daten zu verlangen, sofern keine
                    gesetzlichen Aufbewahrungspflichten bestehen oder die
                    Datenverarbeitung zur Geltendmachung, Ausübung oder
                    Verteidigung von Rechtsansprüchen erforderlich ist.
                  </p>
                </li>
                <li>
                  <p>
                    Nutzer:innen haben das Recht, die Einschränkung der
                    Verarbeitung ihrer personenbezogenen Daten zu verlangen,
                    wenn die Richtigkeit der Daten bestritten wird, die
                    Verarbeitung unrechtmäßig ist, die Daten aber nicht gelöscht
                    werden sollen, oder wenn der Nutzer:innen:innen Widerspruch
                    gegen die Verarbeitung eingelegt hat.
                  </p>
                </li>
                <li>
                  <p>
                    Nutzer:innen haben das Recht, ihre personenbezogenen Daten
                    in einem strukturierten, gängigen und maschinenlesbaren
                    Format zu erhalten oder die Übermittlung dieser Daten an
                    einen anderen Verantwortlichen zu verlangen.
                  </p>
                </li>
                <li>
                  <p>
                    Nutzer:innen haben das Recht, ihre Einwilligung zur
                    Verarbeitung personenbezogener Daten jederzeit zu
                    widerrufen. Der Widerruf wirkt jedoch nicht rückwirkend und
                    berührt die Rechtmäßigkeit der Verarbeitung aufgrund der
                    Einwilligung bis zum Widerruf nicht.
                  </p>
                </li>
                <li>
                  <p>
                    Nutzer:innen haben das Recht, sich bei einer
                    Aufsichtsbehörde zu beschweren, wenn sie der Ansicht sind,
                    dass die Verarbeitung ihrer personenbezogenen Daten gegen
                    die DSGVO verstößt.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h3>Widerspruchsrecht</h3>
              <p>
                Nutzer:innen haben das Recht, aus Gründen, die sich aus ihrer
                besonderen Situation ergeben, jederzeit gegen die Verarbeitung
                ihrer personenbezogenen Daten Widerspruch einzulegen, sofern die
                Verarbeitung aufgrund eines berechtigten Interesses erfolgt. Im
                Falle eines Widerspruchs werden wir die personenbezogenen Daten
                nicht mehr verarbeiten, es sei denn, wir können zwingende
                schutzwürdige Gründe für die Verarbeitung nachweisen, die die
                Interessen, Rechte und Freiheiten der betroffenen Person
                überwiegen, oder die Verarbeitung dient der Geltendmachung,
                Ausübung oder Verteidigung von Rechtsansprüchen.
              </p>
            </li>
            <li>
              <h3>Datensicherheit</h3>
              <p>
                Wir setzen technische und organisatorische Sicherheitsmaßnahmen
                ein, um personenbezogene Daten vor Verlust, unberechtigtem
                Zugriff oder Manipulation zu schützen. Diese Maßnahmen werden
                entsprechend der technologischen Entwicklung fortlaufend
                angepasst.
              </p>
            </li>
            <li>
              <h3>Änderungen der Datenschutzerklärung</h3>
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um
                sie an geänderte Rechtslagen oder bei Änderungen der App oder
                der Datenverarbeitung anzupassen.
              </p>
            </li>
          </ol>
        </Container>
      </section>
    </main>
  );
};

export default DatenschutzScreen;
